import { useTranslation } from 'react-i18next';
import { CustomRadioButton } from '@Components/inputs/RadioButton/CustomRadioButton';
import { FieldError } from '@Components/inputs/FieldError';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

export const BusinessSizeForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-4'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_BUSINESS_SIZE}>
        {({ onChange, value, error }) => (
          <>
            <CustomRadioButton
              label={t('organic.businessSize.small')}
              value='1-5'
              inputId='small-business'
              onChange={onChange}
              checked={value === '1-5'}
              name={EddEmbeddedFields.EDD_BUSINESS_SIZE}
            />
            <CustomRadioButton
              label={t('organic.businessSize.medium')}
              value='6-20'
              inputId='medium-business'
              onChange={onChange}
              checked={value === '6-20'}
              name={EddEmbeddedFields.EDD_BUSINESS_SIZE}
            />
            <CustomRadioButton
              label={t('organic.businessSize.large')}
              value='20+'
              inputId='large-business'
              onChange={onChange}
              checked={value === '20+'}
              name={EddEmbeddedFields.EDD_BUSINESS_SIZE}
            />
            <FieldError error={error} testId={`${EddEmbeddedFields.EDD_BUSINESS_SIZE}-error`} />
          </>
        )}
      </ControllerWrapper>
    </div>
  );
};
